import React from "react";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";

const Testimonials: React.FC = () => {
  const videoWrapper = (videoLink = "") => {
    return (
      <div className="relative">
        <div
          style={{
            paddingTop: "56.25%",
            backgroundPosition: "50% 50%",
          }}
          className="px-0 pb-0 relative w-full bg-cover"
        >
          <iframe
            src={videoLink}
            frameBorder="0"
            className="absolute left-0 top-0 w-full h-full pointer-events-auto"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    );
  };
  return (
    <div
      style={{
        minHeight: "390px",
        maxWidth: "1150px",
        position: "relative",
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: "40px",
      }}
    >
      <Slider
        {...{
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          arrows: false,
        }}
      >
        <div>
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="px-8 mb-4">
              {videoWrapper(
                "https://www.youtube.com/embed/M5D8ffxYwpo?rel=0&amp;controls=1&amp;autoplay=0&amp;mute=1&amp;start=0"
              )}
            </div>
            <div className="px-8">
              <h2
                className="gradient-text text-lg"
                style={{ width: "max-content" }}
              >
                Testimonials
              </h2>
              <h1 style={{ fontSize: "14px" }}>แหนมดอนเมือง</h1>
              <span>
                “หลังจากที่ใช้ deeple ไปแค่อาทิตย์เดียว ยอดขายของ ช่องทางออนไลน์
                ของแหนมดอนเมืองก็เพิ่มขึ้น 17% แอดมินทำงานน้อยลง การได้ deeple
                เข้ามาใช้ในธุรกิจ ก็เหมือนการได้พนักงานขายดีๆ
                เข้ามาร่วมทีมอีกคนนึงค่ะ”
              </span>
              <br />
              <br />
              <span style={{ fontSize: "12px" }}>
                คุณแตน ธันยวดี วะสีนนท์ รองประธานฝ่ายการตลาด บริษัทไทยอินโนฟู๊ด
              </span>
            </div>
          </div>
        </div>
        <div>
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="px-8 mb-4">
              {videoWrapper(
                "https://www.youtube.com/embed/CxgSJcnmTBw?rel=0&amp;controls=1&amp;autoplay=0&amp;mute=0&amp;start=0"
              )}
            </div>
            <div className="px-8">
              <h2 className="gradient-text" style={{ width: "max-content" }}>
                Testimonials
              </h2>
              <h1 style={{ fontSize: "14px" }}>KCF Mart</h1>
              <span>
                “ปกติเราใช้แอดมิน 10 คน พอเราเปลี่ยนมาใช้ AI Chatbot
                เราเหลือแอดมิน 3 คน แล้วให้แอดมิน ไปทำงานส่วนอื่น
                ประสิทธิภาพของงานก็จะเยอะขึ้น ประสิทธิผลของงาน ก็จะดีขึ้นครับ”
              </span>
              <br />
              <br />
              <span style={{ fontSize: "12px" }}>
                คุณโกญจนาท ศรมยุรา กรรมการผู้จัดการ บริษัท เกษมชัยฟาร์มกรุ๊ป
                จำกัด
              </span>
            </div>
          </div>
        </div>
        <div>
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="px-8 mb-4">
              {videoWrapper(
                "https://www.youtube.com/embed/tarVQkaPXzY?rel=0&amp;controls=1&amp;autoplay=0&amp;mute=0&amp;start=0"
              )}
            </div>
            <div className="px-8">
              <h2 className="gradient-text" style={{ width: "max-content" }}>
                Testimonials
              </h2>
              <h1 style={{ fontSize: "14px" }}>Voice Plaza by Voice TV</h1>
              <span>
                “ระบบของ deeple แทบจะครอบคลุม Sale Process ทั้งหมด
                ตั้งแต่ลูกค้าทักเข้ามาจนถึง ปิดการขาย และ ขนส่ง
                ทำให้เราสามารถเอาเวลาของเรา และทีมงานไปพัฒนาสิ่งอื่นได้
                โดยไม่ต้องกังวลเรื่องการตอบแชทและรับออเดอร์แล้ว”
              </span>
              <br />
              <br />
              <span style={{ fontSize: "12px" }}>
                คุณแบงค์ เสฎฐวุฒิ Digital Marketing Specialist ร้าน Voice Plaza
                by Voice TV
              </span>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  );
};

export default Testimonials;
